import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TestimonialRail } from './components/TestimonialRail';
import { PainSection } from './components/PainSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { UrgencySection } from './components/UrgencySection';
import { OfferSection } from './components/OfferSection';
import { ComparisonSection } from './components/ComparisonSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { CostSection } from './components/CostSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { storyTestimonials, topTestimonials } from './data/salesContent';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-ink-900 font-sans text-body" data-id="element-0" data-mp="23t8eo70bu59r">
      <Hero data-id="element-1" data-mp="3ij64oawq3n8e" />

      <section className="w-full bg-ink-900 pb-16" aria-label="What women are saying" style={{
      paddingBottom: "0px"
    }} data-id="element-2" data-mp="3ijfunyhrpue3">
        <div className="mx-auto max-w-6xl px-5" data-id="element-3" data-mp="3mjgclt42snpw">
          <TestimonialRail items={topTestimonials} hint="← Slide to read more →" data-id="element-4" data-mp="3rdaqgfx028h2" />
        </div>
      </section>

      <main data-id="element-5" data-mp="4n5i12o8na1">
        <PainSection data-id="element-6" data-mp="5gbv0xpxarn" />
        <VolumesSection data-id="element-7" data-mp="7suzhf7pr6a" />
        <BonusesSection data-id="element-8" data-mp="2zld43f9knpe6" />
        <UrgencySection data-id="element-9" data-mp="2zm4xcjfp5b1a" />
        <OfferSection data-id="element-10" data-mp="2zmwit1fkxsdu" />
        <ComparisonSection data-id="element-11" data-mp="2znfyebhrc4op" />

        <section className="w-full bg-ink-800 py-16 sm:py-24" aria-labelledby="stories-title" data-id="element-12" data-mp="33m5e4aq9pybi">
          <div className="mx-auto max-w-6xl px-5" data-id="element-13" data-mp="38l05i12awv78">
            <h2 id="stories-title" className="mb-10 text-center font-display text-3xl font-bold text-white sm:text-[2.75rem]" data-id="element-14" data-mp="3dkus3sf1mymh">
              ❤️ Real Women · Real Results
            </h2>
            <TestimonialRail items={storyTestimonials} hint="← Slide to read their stories →" data-id="element-15" data-mp="studrrrxgr8h" />
          </div>
        </section>

        <GuaranteeSection data-id="element-16" data-mp="3uct3bjmdin0h" />
        <FaqSection data-id="element-17" data-mp="3udkn7x6lywax" />
        <CostSection data-id="element-18" data-mp="3ubzvsgflbtha" />
        <OfferSection id="final-offer" eyebrow="Last Call — Launch Price" heading="Start This Week, Not Next Year" data-id="element-19" data-mp="3uevsk1fpcc45" />
      </main>

      <Footer data-id="element-20" data-mp="86w7kxrkyi3h" />
      <StickyCta data-id="element-21" data-mp="864djrdmssfb" />
    </div>;
}